import React, { useMemo } from "react";
import BlocoConteudoEscolha from "./BlocoConteudoEscolha";
import {
  MAX_CONTEUDOS_REGULARES,
  MAX_VAGAS_POR_CONTEUDO,
  idsConteudosRegulares,
} from "./conteudosAgendaUtils";

export default function PassoConteudos({
  dias = [],
  catalogo,
  selectedIds,
  onChangeSelected,
}) {
  const regulares = useMemo(
    () => idsConteudosRegulares(selectedIds, catalogo),
    [selectedIds, catalogo],
  );

  if (!dias.length) {
    return (
      <div className="c26-step-panel">
        <p className="c26-lead">
          Nenhum conteúdo disponível no momento. Tente novamente mais tarde ou
          fale com a organização do evento.
        </p>
      </div>
    );
  }

  return (
    <div className="c26-step-panel">
      <p className="c26-lead">
        Selecione os conteúdos que deseja acompanhar. Cada conteúdo tem limite de {MAX_VAGAS_POR_CONTEUDO} vagas.
      </p>
      <p className="cc-passo-contador">
        Conteúdos: {regulares.length}/{MAX_CONTEUDOS_REGULARES}
      </p>

      {dias.map((dia) => (
        <section key={dia.data || dia.label} className="cc-dia-secao">
          <h2 className="cc-dia-titulo">{dia.label}</h2>
          <div className="cc-dia-blocos">
            {(dia.slots || []).map((slot) => (
              <BlocoConteudoEscolha
                key={slot.id}
                horario={slot.horario_label || slot.descricao}
                eventos={slot.conteudos || []}
                selectedIds={selectedIds}
                onChangeSelected={onChangeSelected}
                catalogo={catalogo}
                disponivel
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
